'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Card.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Card = function (props) {
    var className = props.className, children = props.children, onClick = props.onClick;
    return (React__default['default'].createElement("div", { className: "card-root " + ((className === null || className === void 0 ? void 0 : className.container) || ''), onClick: onClick },
        React__default['default'].createElement("div", { className: 'line' }),
        React__default['default'].createElement("div", { className: "content " + ((className === null || className === void 0 ? void 0 : className.content) || '') }, children)));
};
Card.defaultProps = {
    animate: true,
};

exports.Card = Card;
exports.default = Card;
//# sourceMappingURL=Card.js.map
